// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GroupDetailsActionTypes, LoadingGroupDetailsAction,
    CompleteLoadGroupDetailsAction, FailLoadGroupDetailsAction } from './group-details.actions';
import { GroupsService } from '../../core/services/group.service';
import { CompleteLoadUsersFromGroupAction } from './group-details.actions';

@Injectable()
export class GroupDetailsEffects {

  @Effect()
  requestOnLoadGroups$ = this.actions$.pipe(
    ofType(GroupDetailsActionTypes.GROUP_DETAILS_LOADING),
    switchMap(({ payload }: any) =>
      this.groupsService.get(payload).pipe(
        map((group) => new CompleteLoadGroupDetailsAction(group as any)),
        catchError(() => of(new FailLoadGroupDetailsAction(payload)))
      )
    )
  );

  @Effect()
  requestUsersOnLoadGroups$ = this.actions$.pipe(
    ofType(...[
      GroupDetailsActionTypes.GROUP_DETAILS_LOADING_USERS,
      GroupDetailsActionTypes.GROUP_DETAILS_USERS_REMOVE_BY_ID
    ]),
    switchMap(({ payload }: any) =>
      this.groupsService.getUsersFromGroup(payload).pipe(
        map((users) => new CompleteLoadUsersFromGroupAction(payload, users)),
        catchError(() => of(new FailLoadGroupDetailsAction(payload)))
      )
    )
  );

  constructor(private actions$: Actions, private groupsService: GroupsService) {}
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/group-details/group-details.effects.ts